import React from "react";
import PropTypes from "prop-types";

import styles from "./LoadingDots.css";

const LoadingDots = props => {
  return (
    <div className={styles.root}>
      <div className={styles.dot}>·</div>
      <div className={styles.dot}>·</div>
      <div className={styles.dot}>·</div>
    </div>
  );
};

export default LoadingDots;
